import { CASE_CATEGORIES } from "./caseCategories";

/**
 * Case category picker.
 * value: { category: string label, subcategory: string label, sonstige_text: string }
 */
export const FallKategorie = ({ value, onChange }) => {
  const setCategory = (label) => {
    // Reset subcategory when category changes
    onChange({ category: label, subcategory: "", sonstige_text: value.sonstige_text || "" });
  };
  const setSub = (label) => {
    onChange({ ...value, subcategory: label });
  };
  const setSonstige = (text) => {
    onChange({ ...value, sonstige_text: text });
  };

  const activeCat = CASE_CATEGORIES.find((c) => c.label === value.category);

  return (
    <div>
      <span className="eyebrow text-[#505a74]">
        Worum geht es?
      </span>
      <div className="mt-3 flex flex-wrap gap-2">
        {CASE_CATEGORIES.map((c) => {
          const active = value.category === c.label;
          return (
            <button
              key={c.id}
              type="button"
              data-testid={`fall-cat-${c.id}`}
              onClick={() => setCategory(c.label)}
              className={`px-4 py-2.5 rounded-full text-[13px] font-semibold border transition ${
                active
                  ? "bg-[#0a1128] text-white border-[#0a1128]"
                  : "bg-white text-[#0a1128] border-[#e8e6df] hover:border-[#0a1128]"
              }`}
            >
              {c.label}
            </button>
          );
        })}
      </div>

      {/* Subcategories (only if active category has children) */}
      {activeCat && activeCat.children.length > 0 && (
        <div
          data-testid="fall-subcategories"
          className="mt-5 pl-4 border-l-2 border-[#d90429]"
        >
          <span className="eyebrow text-[#505a74]">
            Genauer:
          </span>
          <div className="mt-3 flex flex-wrap gap-2">
            {activeCat.children.map((sub) => {
              const active = value.subcategory === sub.label;
              return (
                <button
                  key={sub.id}
                  type="button"
                  data-testid={`fall-sub-${sub.id}`}
                  onClick={() => setSub(sub.label)}
                  className={`px-3.5 py-2 rounded-full text-[12px] font-semibold border transition ${
                    active
                      ? "bg-[#d90429] text-white border-[#d90429]"
                      : "bg-white text-[#0a1128] border-[#e8e6df] hover:border-[#d90429]"
                  }`}
                >
                  {sub.label}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {/* Free text for "Sonstige" */}
      {value.category === "Sonstige" && (
        <div data-testid="fall-sonstige-input" className="mt-5">
          <label className="block">
            <span className="eyebrow text-[#505a74]">
              Bitte kurz beschreiben
            </span>
            <textarea
              value={value.sonstige_text || ""}
              onChange={(e) => setSonstige(e.target.value)}
              rows={3}
              data-testid="form-input-fall-sonstige"
              placeholder="Worum geht es in 1–2 Sätzen?"
              className="mt-2 block w-full bg-white border border-[#e8e6df] rounded-sm px-4 py-3 text-[14px] focus:outline-none focus:border-[#0a1128] transition"
            />
          </label>
        </div>
      )}

      <p className="mt-4 text-[11px] text-[#505a74]">
        Diese Information hilft uns bei der ersten Einschätzung. Sie wird nicht
        in die Adressdatei aufgenommen.
      </p>
    </div>
  );
};
